export default __webpack_public_path__ + "static/media/Questrial-Regular.96dd668f.ttf";